<template>
    <div class="co-meus-modelos-lista-vazia mt-4">
        <clm-ops sentimento="triste">
            <div slot="titulo">Ops! Não encontrei nada por aqui</div>
            <div slot="subtitulo">
                <span>Clique agora em <strong>Criar Modelo</strong> para começar.</span><br/>
            </div>
        </clm-ops>

    </div>
</template>

<script>
import ClmOps from '@/commons/components/ClmOps'

export default {
    name: 'ListaVazia',
    components: {
        ClmOps
    },
}
</script>

<style lang="stylus">
.co-meus-modelos-lista-vazia
    color unset

</style>
